import { Card } from "antd";
import styled from "styled-components";

import color from "../_style/color";

const Box = styled(Card)`
  .ant-card-body {
    padding: 20px;
  }

  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-radius: 2px;
  flex-direction: column;
`;

export default Box;
